import { DataTypeSearchCombo, SearchQuery } from '../Query';

export const isSearchQuery = (query?: SearchQuery | DataTypeSearchCombo): query is SearchQuery =>
  !!query && 'searchQueries' in query;
